var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlmirah(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#666",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.87 20.64H6.69a1.08 1.08 0 01-1.08-1.08V4.44c0-.596.484-1.08 1.08-1.08h5.18v17.28z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.049 20.64h-5.18V3.36h5.18c.596 0 1.08.484 1.08 1.08v15.12a1.08 1.08 0 01-1.08 1.08zM11.869 13.772h6.259M11.869 17.039h6.259M14.117 15.334h1.522M14.117 18.743h1.522"
  })))));
}
export default SvgAlmirah;